import React from 'react'

export default function MetricSkel() {
  return (
        <div className='metrics-container'>
            <div className="filter-action">
                <select disabled>
                    <option value=""></option>
                </select>
                <select disabled>
                    <option value=""></option>
                </select>
                <select disabled>
                    <option value=""></option>
                </select>
                {/* <input type="button" value="" style={{float:'right',width:'90px',backgroundColor:'#DDDDDD'}}/> */}
            </div>
            <div className='details01'>
                <div className="box01" style={{border:'none',boxShadow:'none'}}>
                    <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',margin:'0px 0'}}>
                    <div style={{width:'32%',height:'90%',margin:'0 5px 0 0',border:'1px solid #EBEBEB',boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',position:'relative',borderRadius:'8px'}}>
                        <span className='title-task metrics-skel'>000000000000000</span>
                         <div className='number-task'>
                            <span className='metrics-skel'>0000</span>
                        </div>
                    </div>
                    <div style={{width:'32%',height:'90%',margin:'0 5px',border:'1px solid #EBEBEB',boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',position:'relative',borderRadius:'8px'}}>
                        <span className='title-task metrics-skel'>000000000000000</span>
                        <div className='number-task'>
                            <span className='metrics-skel'>0000</span>
                        </div>
                    </div>
                    <div style={{width:'32%',height:'90%',margin:'0 0 0 5px',border:'1px solid #EBEBEB',boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',position:'relative',borderRadius:'8px'}}>
                        <span className='title-task metrics-skel'>000000000000000</span>
                        <div className='number-task'>
                            <span className='metrics-skel'>0000</span>
                        </div>
                    </div>
                    </div>
                </div>
                
                <div className="box01" style={{border:'none',boxShadow:'none'}}>
                    <div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',margin:'0'}}>
                        <div style={{width:'32%',height:'90%',margin:'0 5px 0 0',border:'1px solid #EBEBEB',boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',position:'relative',borderRadius:'8px'}}>
                            <span className='title-task metrics-skel'>000000000000000</span>
                            <div className='number-task'>
                                <span className='metrics-skel'>0000</span>
                            </div>
                        </div>
                        <div style={{width:'32%',height:'90%',margin:'0 5px',border:'1px solid #EBEBEB',boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',position:'relative',borderRadius:'8px'}}>
                            <span className='title-task metrics-skel'>000000000000000</span>
                            <div className='number-task'>
                               <span className='metrics-skel'>0000000</span>
                            </div>
                        </div>
                        <div style={{width:'32%',height:'90%',margin:'0 0 0 5px',border:'1px solid #EBEBEB',boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',position:'relative',borderRadius:'8px'}}>
                            <span className='title-task metrics-skel'>000000000000000</span>
                            <div className='number-task'>
                                <span className='metrics-skel'>0000</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <div className="details02" style={{display:'inline-block',width:'100%',overflow:'hidden',whiteSpace:'nowrap'}}>
            <div className="bbox" id='div-graph01' style={{width:'calc(50% - 32px)',display:'flex',flexWrap:'wrap',gap:'1em',border:'1px solid #EBEBEB',background:'#FFFFFF'}}>
                <div style={{width:'100%',height:'49%'}}>
                    <div className='metrics-skel' style={{ width:'100px',margin:'10px'}}>0000000000</div>
                    <div className='metrics-skel' style={{width:'97%',height:'calc(100% - 50px)',margin:'10px auto'}}>
                    
                    </div>
                </div>
                <div style={{width:'100%',height:'49%'}}>
                    <div className='metrics-skel' style={{ width:'100px',margin:'10px'}}>0000000000</div>
                    <div className='metrics-skel' style={{width:'97%',height:'calc(100% - 50px)',margin:'10px auto'}}>
                    
                    </div>  
                </div>
            </div>
            <div className="bbox" id='div-graph02' style={{width:'calc(50% - 32px)',display:'flex',flexWrap:'wrap',gap:'1em',border:'1px solid #EBEBEB',background:'#FFFFFF'}}>
                <div style={{width:'48.5%',height:'49%'}}>
                    <div className='metrics-skel' style={{ width:'100px',margin:'10px'}}>0000000000</div>
                    <div className='metrics-skel' style={{width:'97%',height:'calc(100% - 50px)',margin:'10px auto'}}>
                    
                    </div>   
                </div>
                <div style={{width:'48.5%',height:'49%'}}>
                    <div className='metrics-skel' style={{ width:'100px',margin:'10px'}}>0000000000</div>
                    <div className='metrics-skel' style={{width:'97%',height:'calc(100% - 50px)',margin:'10px auto'}}>
                    
                    </div>    
                </div>
                <div style={{width:'48.5%',height:'49%'}}>
                    <div className='metrics-skel' style={{ width:'100px',margin:'10px'}}>0000000000</div>
                    <div className='metrics-skel' style={{width:'97%',height:'calc(100% - 50px)',margin:'10px auto'}}>
                    
                    </div>      
                </div>
                <div style={{width:'48.5%',height:'49%'}}>
                    <div className='metrics-skel' style={{ width:'100px',margin:'10px'}}>0000000000</div>
                    <div className='metrics-skel' style={{width:'97%',height:'calc(100% - 50px)',margin:'10px auto'}}>
                    
                    </div>
                </div>
            </div>
        </div>
    </div> 
  )
}
